<template>
    <div>
        <p v-if="d === false" style="text-align: center" >
            <span @click="d = true" class="btn btn-lg btn-success my-2">Afficher le téléphone et l'adresse e-mail.</span>
        </p>
        <p class="jumbotron center h5 shadow-sm" v-else>
            E-mail : <a :href="completeParam">{{ complete }}</a><br><br>
            Téléphone : <a :href="telRef" class="btn btn-primary m-1">{{ telephone }}</a><br>
            Gsm : <a :href="gsmRef" class="btn btn-primary m-1">{{ gsm }}</a>
        </p>
    </div>
</template>

<script>
export default {
  name: 'ContactBox',
  data () {
    return {
      d: false,
      partOne: 'bernard.darras',
      partTwo: 'hotmail',
      partThree: 'com',
      telephone: '0032 (0) 69 21 01 44',
      telRef: 'tel:+3269210144',
      gsmRef: 'tel:+32471409382',
      gsm: '0032 (0) 471 40 93 82'
    }
  },
  computed: {
    complete () {
      return this.partOne + '@' + this.partTwo + '.' + this.partThree
    },
    completeParam () {
      return 'mailto:' + this.complete
    }
  }
}
</script>
